module.exports = __webpack_public_path__ + "img/station-mobile.fcefba8b.webp";